import { render } from "./OfficeMenu.vue?vue&type=template&id=a2338b28"
import script from "./OfficeMenu.vue?vue&type=script&lang=js"
export * from "./OfficeMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__